// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amp-layout__wrapper{max-width:800px;margin:0 auto}.amp-layout__content-container{padding:85px 15px 0}@media (max-width:767px){.amp-layout__content-container{padding-left:10px;padding-right:10px}}amp-consent{background-color:rgba(1,1,1,.6)}amp-consent .amp-consent__popup{margin:0 auto;position:relative;width:100%;height:100vh}amp-consent .amp-consent__popup .amp-active{display:none}amp-consent .amp-consent__popup amp-iframe{background-color:rgba(0,0,0,0)}", ""]);
// Exports
module.exports = exports;
